//
const home = [
  {
    path: "/home",
    name: "home",
    // hide: true,
    icon: "s-icon-home",
    title: "Home",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/home"),
  },
];

//
const gameManage = [
  {
    path: "/game/manage",
    name: "game-manage",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Game/Manage",
    access: "game.manage.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/game/manage"),
  },
];
//
const gameNews = [
  {
    path: "/game/news",
    name: "game-news",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Game/News",
    access: "game.news.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/game/news"),
  },
];
const gameRecommend = [
  {
    path: "/game/recommend",
    name: "game-recommend",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Game/Recommend",
    access: "game.recommend.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/game/recommend"),
  },
];
const idoProject = [
  {
    path: "/launchpad/ido/project",
    name: "launchpad-ido-project",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Launchpad/IDO/Project",
    access: "ido.project.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/ido/project"),
  },
];
const idoStation = [
  {
    path: "/launchpad/ido/station",
    name: "launchpad-ido-station",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Launchpad/IDO/Station",
    access: "ido.station.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/ido/station"),
  },
];
const idoRecommend = [
  {
    path: "/launchpad/ido/recommend",
    name: "launchpad-ido-recommend",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Launchpad/IDO/Recommend",
    access: "ido.recommend.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/ido/recommend"),
  },
];
const nftProject = [
  {
    path: "/nft/project",
    name: "nft-project",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "NFT/Project",
    access: "nft.project.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/nft/project"),
  },
];
const nftRecommend = [
  {
    path: "/nft/recommend",
    name: "nft-recommend",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "NFT/Recommend",
    access: "nft.recommend.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/nft/recommend"),
  },
];
const nftStation = [
  {
    path: "/nft/station",
    name: "nft-station",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "NFT/Station",
    access: "nft.station.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/nft/station"),
  },
];
const missionManage = [
  {
    path: "/mission/manage",
    name: "mission-manage",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Mission/Manage",
    access: "mission.manage.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/mission/manage"),
  },
];
// const missionAvatarFrame = [
//   {
//     path: "/mission/avatarFrame",
//     name: "mission-avatarFrame",
//     // hide: true,
//     icon: "s-icon-yewuguanli",
//     title: "Mission/Avatar Frame",
//     access: "mission.frame.view",
//     component: () => import(/* webpackChunkName: "back" */ "@/views/pages/mission/avatarFrame"),
//   },
// ];
const missionMedal = [
  {
    path: "/mission/medal",
    name: "mission-medal",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Mission/Medal",
    access: "mission.medal.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/mission/medal"),
  },
];
const dailyNews = [
  {
    path: "/feeds/dailynews",
    name: "feeds-dailyNews",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Feeds/Daily News",
    access: "feeds.dailynews.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/feeds/dailynews"),
  },
];
const feedsHelp = [
  {
    path: "/feeds/help",
    name: "feeds-article center",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Feeds/Article Center",
    access: "feeds.help.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/feeds/help"),
  },
];
const feedsRecommend = [
  {
    path: "/feeds/recommend",
    name: "feeds-recommend",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Feeds/Recommend",
    access: "feeds.newsrecommend.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/feeds/recommend"),
  },
];
const token = [
  {
    path: "/token",
    name: "token",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Token",
    access: "other.token.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/token"),
  },
];
const marketingMember = [
  {
    path: "/marketing/member",
    name: "marketing-member",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Marketing/Member",
    access: "marketing.member.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/marketing/member"),
  },
];
const marketingSubscribe = [
  {
    path: "/marketing/subscribe",
    name: "marketing-subscribe",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Marketing/Subscribe",
    access: "marketing.subscribe.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/marketing/subscribe"),
  },
];
const marketingFeedback = [
  {
    path: "/marketing/feedback",
    name: "marketing-feedback",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Marketing/Feedback",
    access: "marketing.feedback.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/marketing/feedback"),
  },
];
const marketingSubSend = [
  {
    path: "/marketing/subsend",
    name: "marketing-subsend",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Marketing/Subscribe Send",
    access: "marketing.send.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/marketing/subsend"),
  },
];
const marketingMarkForm = [
  {
    path: "/marketing/markform",
    name: "marketing-markform",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Marketing/Market Form",
    access: "marketing.form.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/marketing/markform"),
  },
];
const settingEnum = [
  {
    path: "/setting/enum",
    name: "setting-enum",
    // hide: true,
    icon: "s-icon-zhanghuguanli",
    title: "Setting/Enum",
    access: "setting.enum.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/setting/enum"),
  },
];
const settingStaff = [
  {
    path: "/setting/staff",
    name: "setting-staff",
    // hide: true,
    icon: "s-icon-zhanghuguanli",
    title: "Setting/Staff",
    access: "setting.staff.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/setting/staff"),
  },
];
const settingRole = [
  {
    path: "/setting/role",
    name: "setting-role",
    // hide: true,
    icon: "s-icon-zhanghuguanli",
    title: "Setting/Role",
    access: "setting.role.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/setting/role"),
  },
];

const settingBanner = [
  {
    path: "/setting/banner",
    name: "setting-banner",
    // hide: true,
    icon: "s-icon-zhanghuguanli",
    title: "Setting/Banner",
    access: "setting.banner.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/setting/banner"),
  },
];
const HotWords = [
   {
    path: "/HotWords",
   name: "hotWords",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Hot Words",
    access: "other.hotwords.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/HotWords"),
   },
  ];

const StatsList = [
   {
    path: "/StatsList",
    name: "StatsList",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Stats",
    access: "other.stats.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/stats"),
   },
  ];
const settingStaffLog = [
  {
    path: "/setting/StaffLog",
    name: "setting-StaffLog",
    // hide: true,
    icon: "s-icon-zhanghuguanli",
    title: "Setting/Staff Log",
    access: "setting.staff.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/setting/staffLog"),
  },
];
const settingApi = [
  {
    path: "/setting/api",
    name: "setting-api",
    // hide: true,
    icon: "s-icon-zhanghuguanli",
    title: "Setting/Api",
    access: "setting.api.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/setting/api"),
  },
];
const inoProject = [
  {
    path: "/launchpad/ino/project",
    name: "launchpad-ino-project",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Launchpad/INO/Project",
    access: "ino.project.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/ino/project"),
  },
];
const inoRecommend = [
  {
    path: "/launchpad/ino/recommend",
    name: "launchpad-ino-recommend",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Launchpad/INO/Recommend",
    access: "ino.recommend.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/ino/recommend"),
  },
];
const inoStation = [
  {
    path: "/launchpad/ino/station",
    name: "launchpad-ino-station",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Launchpad/INO/Station",
    access: "ino.station.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/ino/station"),
  },
];
const communityIssue = [
  {
    path: "/community/issue",
    name: "community-issue",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Community/Hot Issue",
    access: "community.issue.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/community/issue"),
  },
];
const communityPost = [
  {
    path: "/community/post",
    name: "community-post",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Community/Popular Posts",
    access: "community.post.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/community/post"),
  },
];
const communityTag = [
  {
    path: "/community/tag",
    name: "community-tag",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Community/TAG",
    access: "community.tag.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/community/tag"),
  },
];
// const communityCategory = [
//   {
//     path: "/community/category",
//     name: "community-category",
//     // hide: true,
//     icon: "s-icon-yewuguanli",
//     title: "Community/Cate",
//     // access: "community.post.view",
//     component: () => import(/* webpackChunkName: "back" */ "@/views/pages/community/category"),
//   },
// ];
const communityTopic = [
  {
    path: "/community/topic",
    name: "community-topic",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Community/Topic",
    access: "community.topic.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/community/topic"),
  },
];
const communityCommunity = [
  {
    path: "/community/community",
    name: "community-community",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Community/Community",
    access: "community.community.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/community/community"),
  },
];
const communityReport = [
  {
    path: "/community/report",
    name: "community-report",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Community/Report",
    access: "community.report.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/community/report"),
  },
];
const communityRecommend = [
  {
    path: "/community/recommend",
    name: "community-recommend",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Community/Recommend",
    access: "community.postrecommend.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/community/recommend"),
  },
];

const communityMessage = [
  {
    path: "/community/message",
    name: "community-message",
    // hide: true,
    icon: "s-icon-yewuguanli",
    title: "Marketing/Message",
    access: "community.message.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/community/message"),
  },
];
const settingIP = [
  {
    path: "/setting/ip",
    name: "setting-ip",
    // hide: true,
    icon: "s-icon-zhanghuguanli",
    title: "Setting/IP",
    access: "setting.ip.view",
    component: () => import(/* webpackChunkName: "back" */ "@/views/pages/setting/IP"),
  },
];

var menu = [
  ...home,
  ...gameManage,
  ...gameNews,
  ...gameRecommend,
  ...nftProject,
  ...nftStation,
  ...nftRecommend,
  ...idoProject,
  ...idoStation,
  ...idoRecommend,
  ...inoProject,
  ...inoStation,
  ...inoRecommend,
  ...dailyNews,
  ...feedsHelp,
  ...feedsRecommend,
  ...missionManage,
  ...missionMedal,
  // ...missionAvatarFrame,
  ...communityCommunity,
  ...communityPost,
  ...communityIssue,
  ...communityTag,
  ...communityTopic,
  ...communityReport,
  ...communityRecommend,
  ...communityMessage,
  ...token,
  ...HotWords,
  ...StatsList,
  ...marketingMember,
  ...marketingSubscribe,
  ...marketingFeedback,
  ...marketingSubSend,
  ...marketingMarkForm,
  ...settingBanner,
  ...settingEnum,
  ...settingStaff,
  ...settingRole,
  ...settingApi,
  ...settingStaffLog,
  ...settingIP,
];
function getAccess() {
  let accessRs = {};
  if (localStorage.getItem("userInfo")) {
    let user = JSON.parse(localStorage.getItem("userInfo"));
    let access = user.userInfo.access || {};
    for (let mk in access) {
      var m = {},
        ma = false;
      for (let gk in access[mk]) {
        var g = {},
          ga = false;
        for (let k in access[mk][gk]) {
          if (access[mk][gk][k]) {
            g[k] = 1;
            ga = true;
          }
        }
        if (ga) {
          m[gk] = g;
          ma = true;
        }
      }
      if (ma) {
        accessRs[mk] = m;
      }
    }
  }
  // console.log(accessRs);
  return accessRs;
}
(function () {
  let access = getAccess();
  let tempMenu = [];
  for (let i in menu) {
    if (menu[i].access) {
      let [mk, gk, k] = menu[i].access.split(".");
      if (access[mk] && access[mk][gk]) {
        if (k && access[mk][gk][k]) {
          tempMenu.push(menu[i]);
        }
      }
    } else {
      tempMenu.push(menu[i]);
    }
  }
  menu = tempMenu;
})();

//
export default [
  {
    path: "/",
    redirect: "/home",
    name: "menus",
    component: () => {
      return import(/* webpackChunkName: "back" */ "@/views/layout");
    },
    children: menu,
  },

  // {
  //   path: "/editor",
  //   name: 'editor',
  //   component: () => import(/* webpackChunkName: "back" */ "@/views/editPage/editPage"),
  //   meta: {
  //     hideInMenu: true,
  //     notCache: true
  //   }
  // },
  {
    path: "/login",
    name: "login",
    component: () => {
      return import(/* webpackChunkName: "back" */ "@/views/login/login");
    },
    meta: {
      hideInMenu: true,
      notCache: true,
    },
  },
  {
    path: "/register",
    name: "register",
    component: () => {
      return import(/* webpackChunkName: "back" */ "@/views/register");
    },
    meta: {
      hideInMenu: true,
      notCache: true,
    },
  },
  {
    path: "/forgetPwd",
    name: "forgetPwd",
    component: () => {
      return import(/* webpackChunkName: "back" */ "@/views/forgetPwd");
    },
    meta: {
      hideInMenu: true,
      notCache: true,
    },
  },
];
